import { combineReducers } from 'redux';
import reducerPedido from './reducer-pedido';
import reducerProdutos from './reducer-produtos';
import reducerServicos from './reducer-servicos';
import reducerTermosUso from './reducer-termosUso';

export default combineReducers({
    reducerPedido,
    reducerProdutos,
    reducerServicos,
    reducerTermosUso
})